import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetOpeningStockDetailsQuery } from '../slices/openingStocksApiSlice';

const OpeningStockScreen = () => {
  const { id: openingStockId } = useParams();

  const { data: openingStock, refetch, isLoading, error } = useGetOpeningStockDetailsQuery(openingStockId);

  useEffect(() => {
    if (!openingStock) {
      refetch();
    }
  }, [openingStock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>OpeningStock {openingStock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Supplier Details</h2>
              <p>
                <strong>Name: </strong> {openingStock?.supplierDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {openingStock?.supplierDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {openingStock?.supplierDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {openingStock?.supplierDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {openingStock?.supplierDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>OpeningStock Note</h2>
              <p>{openingStock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>OpeningStock Items</h2>
              {openingStock?.openingStockItems?.length === 0 ? (
                <Message>This openingStock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {openingStock?.openingStockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>OpeningStock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{openingStock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>${openingStock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{openingStock?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OpeningStockScreen;